import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomDropDown from '../../shared-components/custom-drop-down/CustomDropDown';
import PageTitle from '../../shared-components/page-title/PageTitle';
import getFirstSubdomain from '../../shared-functions/DomainsplitFunction';

import General from './General';
import Payout from './Payout';

/**
 * Settings page component
 * @returns
 */
function Settings() {
  const { t } = useTranslation('setting');
  const subdomain = getFirstSubdomain();
  const shouldHideAccessUtility = Boolean(subdomain);
  return (
    <div className="setting-warp">
      <PageTitle title={t('settings')} />
      <div className="setting-container">
        <div className="dropdown-group">
          <CustomDropDown label={t('general')} content={<General />} />
          {!shouldHideAccessUtility && <CustomDropDown label={t('payout')} content={<Payout />} />}
        </div>
      </div>
    </div>
  );
}

export default Settings;
